import { Modal } from 'antd';
import { useModalConfigContext } from '../../../../contexts/ModalConfigContext/ModalConfigContext';
import { useOpen } from '../../../../hooks/useBoolean/useOpen';
import { DeviceModelEnum } from '../../../../uc-api-sdk';
import { EllipsisComponent } from '../../../../uiComponent/EllipsisComponent/EllipsisComponent';
import { LinkButton } from '../../../../uiComponent/LinkButton/LinkButton';
import { OrderType } from '../../type';
import { DeviceReplacementCheckboxComponent, DeviceReplacementCheckboxComponentProps, DeviceReplacementValue } from '../DeviceReplacementCheckboxComponent/DeviceReplacementCheckboxComponent';
import { OrderInfoComponent } from '../OrderInfoComponent/OrderInfoComponent';
import { CellularDeviceAssignFormComponent, CellularDeviceAssignFormComponentProps } from '../../../enrollment/component/CellularDeviceAssignFormComponent/CellularDeviceAssignFormComponent';
import { DeviceMonitorMethodEnum } from '../../../../enumComponent/DeviceMonitorMethodEnumComponent/DeviceMonitorMethodEnumComponent';

export interface CellularDeviceReplacementValue extends DeviceReplacementValue {
  deviceId?: string;
  deviceModel?: DeviceModelEnum;
  deviceMethod?: DeviceMonitorMethodEnum;
}

export interface CellularDeviceReplacementComponentProps {
  deviceModel: DeviceModelEnum;
  value?: CellularDeviceReplacementValue;
  onChange?: (value?: CellularDeviceReplacementValue) => void;
  onUncheck?: (deviceId: string) => void;
}

export const CellularDeviceReplacementComponent = ({
  deviceModel,
  value,
  onChange,
  onUncheck,
}: CellularDeviceReplacementComponentProps) => {
  const {
    isChecked = false,
    reason,
    deviceId,
  } = value || {};
  const {
    isOpen,
    open,
    close,
  } = useOpen();
  const {
    getContainer: getModalContainer,
  } = useModalConfigContext();

  const handleOnChange: DeviceReplacementCheckboxComponentProps['onChange'] = (
    newValue
  ) => {
    const {
      isChecked = false,
      reason: newReason,
    } = newValue || {};
    if (isChecked && newReason && !deviceId) {
      // only automatically open the modal when it's initial change
      open();
    }
    if (!isChecked) {
      onChange?.({ isChecked, reason: newReason });
      onUncheck?.(deviceId as string);
      return;
    }
    onChange?.({
      ...value,
      isChecked,
      reason: newReason,
    });
  };

  const handleOnDeviceSubmit: CellularDeviceAssignFormComponentProps['onSubmit'] = (
    deviceSetupValue,
  ) => {
    onChange?.({
      ...value,
      ...deviceSetupValue,
      deviceMethod: DeviceMonitorMethodEnum.NON_APP_MONITOR,
      deviceModel,
    });
    close();
  };

  const handleOnCancelDeviceAssignment = () => {
    if (!deviceId) {
      onChange?.({ isChecked: false, reason });
    }
    close();
  };

  return (
    <>
      <DeviceReplacementCheckboxComponent
        value={value}
        onChange={handleOnChange}
        showExtraContent={isChecked && !!reason && !!deviceId}
        extraContent={(
          <div className="flex f-w ai-c">
            <EllipsisComponent>
              Device ID:
              {' '}
              {deviceId || 'Not assigned'}
            </EllipsisComponent>
            <LinkButton
              useBlueColor
              onClick={open}
              className="fs12"
            >
              Edit
            </LinkButton>
          </div>
        )}
      >
        <OrderInfoComponent
          type={OrderType.DEVICES}
          deviceModel={deviceModel}
        />
      </DeviceReplacementCheckboxComponent>
      <Modal
        open={isOpen}
        onCancel={handleOnCancelDeviceAssignment}
        footer={null}
        getContainer={getModalContainer}
        closable={!!deviceId}
        destroyOnClose
      >
        <CellularDeviceAssignFormComponent
          deviceModel={deviceModel}
          initialValues={{ deviceId }}
          onSubmit={handleOnDeviceSubmit}
        />
      </Modal>
    </>
  );
};
